var _defs, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "GRID_ICON",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #GRID_ICON .cls-1,\n      #GRID_ICON .cls-2 {\n        fill: #f5f5f5;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_57",
    "data-name": "Gruppe 57"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_131",
    "data-name": "Pfad 131",
    className: "cls-2",
    d: "M16,2A14,14,0,1,1,2,16,14.041,14.041,0,0,1,16,2m0-2A16,16,0,1,0,32,16,15.983,15.983,0,0,0,16,0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_132",
    "data-name": "Pfad 132",
    className: "cls-1",
    d: "M9,24.3h.7V23.2h2.7v1.1H13V23.2h2.7v1.1h.7V23.2h2.7v1.1h.7V23.2h2.7v1.1h.7V23.2h1.1v-.7H23.2V19.8h1.1v-.7H23.2V16.4h1.1v-.7H23.2V13h1.1v-.7H23.2V9.7h1.1V9.1H23.2V7.9h-.7V9H19.8V7.9h-.7V9H16.4V7.9h-.7V9H13V7.9h-.7V9H9.7V7.9H9V9H7.8v.7H9v2.7H7.8v.7H9v2.7H7.8v.7H9v2.7H7.8v.7H9v2.7H7.8v.7H9Zm4-1.8V19.8h2.7v2.7Zm3.4-6.7V13.1h2.7v2.7Zm2.7.7v2.7H16.4V16.5Zm-3.4-.7H13V13.1h2.7Zm0,.7v2.7H13V16.5Zm.7,6V19.8h2.7v2.7Zm6,0H19.7V19.8h2.7Zm0-3.3H19.7V16.5h2.7Zm0-3.4H19.7V13.1h2.7Zm0-6.1v2.7H19.7V9.7Zm-3.3,0v2.7H16.4V9.7Zm-3.4,0v2.7H13V9.7Zm-6,0h2.7v2.7H9.7Zm0,3.4h2.7v2.7H9.7Zm0,3.4h2.7v2.7H9.7Zm0,3.3h2.7v2.7H9.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.84694b5dda68b2fa5fc460b9c0dde937.svg";
export { ForwardRef as ReactComponent };